import { PortfolioEntry, Project } from "@/interfaces/account";
import { createAppSlice } from "@/lib/store/createAppSlice";
import { IFaqTranslation } from "@/server/models/Mongoose/FaqTranslation";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ContentSliceState {
  showDrawerProfile: boolean;
  showMissedCallsDrawer: boolean;
  status: "idle" | "loading" | "failed";
  updaterSection: string;
  showDrawerPh: boolean;
  showMegaMenu: boolean;
  showDrawerSamples: boolean;
  showDrawerReview: boolean;
  showFeedbackModal: boolean;
  accountType: string;
  showCareersDrawer: boolean;
  showAddFaqDrawer: boolean;
  showFaqCategoriesDrawer: boolean;
  selectedCategoryForFaq: any;

  refetchSamples: boolean;
  refetchPh: boolean;
  project: Project | null;
  sample: PortfolioEntry | null;
  editFaq: IFaqTranslation[] | null;
  interpreterPoolBioDraft: string;
  interpreterPoolVideoDraft: string;
}

const initialState: ContentSliceState = {
  status: "idle",
  updaterSection: "Profile Updater",

  // Bit to open/close drawers
  showFeedbackModal: false,
  showDrawerProfile: false,
  showMissedCallsDrawer: false,
  showDrawerReview: false,
  showDrawerPh: false,
  showDrawerSamples: false,
  showMegaMenu: false,
  accountType: "freelancer",
  showCareersDrawer: false,
  showAddFaqDrawer: false,
  showFaqCategoriesDrawer: false,
  selectedCategoryForFaq: null,

  // Bits to set to reerect data from react toolkit query
  refetchPh: false,
  refetchSamples: false,
  // Data to set here to edit
  project: null,
  sample: null,
  editFaq: null,
  interpreterPoolBioDraft: "",
  interpreterPoolVideoDraft: "",
};

// If you are not using async thunks you can use the standalone `createSlice`.
export const contentSlice = createAppSlice({
  name: "content",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: (create) => ({
    setContentSliceBits: create.reducer(
      (state, action: PayloadAction<{ bitToSet: keyof ContentSliceState; value: any }>) => {
        const { bitToSet, value } = action.payload;
        // @ts-ignore
        state[bitToSet] = value; // Update the specific bit
      }
    ),
  }),
});

export const { setContentSliceBits } = contentSlice.actions;
export const contentReducer = contentSlice.reducer;
